import React from 'react'
import { Col, Grid, Skeleton } from 'gu-ui-kit'
export const Placeholder = () => (
  <Skeleton shown>
    <Grid
      gap={16}
      style={{ height: '100%' }}
      alignItems={'space-between'}
      direction={'column'}
    >
      <Col
        flexShrink={1}
        flexGrow={1}
      >
        <Skeleton.Item
          height={40}
          width={250}
        />
      </Col>
      <Col
        flexShrink={0}
        flexGrow={0}
      >
        <Grid
          gap={16}
          direction={'column'}
        >
          <Skeleton.Item
            height={52}
            width={'100%'}
          />
          <Skeleton.Item
            height={52}
            width={'100%'}
          />
        </Grid>
      </Col>
    </Grid>
  </Skeleton>
)
